import React from 'react';
import './RoomInfo.css';

const RoomInfo = ({ title, features}) => {
  console.log(features);
  return (
    <div className="room-info">
      <h1 className="room-info-title">{title}</h1>
      
      <div className="room-info-features">
        { features.map( (feature, index)=> 
        (
          <div key={index} className="room-info-feature">
          <span className="material-symbols-outlined notranslate">{feature.icon}</span>
          <p>{feature.text}</p>
          </div>
        )) }
        
      </div>
    </div>
  );
};

export default RoomInfo;